import type {GetLottieAnimationFn} from '../../../uikit/LottieView/types';

import {lottieColorify} from '../../../uikit/LottieView/colorify';
import animationJson from './animation.json';

export const getWaitingRoomBirdAnimation: GetLottieAnimationFn = (
  color: string,
) => {
  return lottieColorify({
    color,
    source: animationJson,
  });
};
